import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

const messages = localsMessages('common/subHeader')

const STYLES = {
	headerPurpose: {
		marginBottom: '0px',
		lineHeight: '1.3',
		fontFamily: 'pp-sans-big-regular',
		fontSize: 15,
	},
	headerDonationId: {
		margin: '0px',
		lineHeight: '1.3',
		fontFamily: 'pp-sans-big-regular',
		fontSize: 15,
	}
}

class SubHeader extends React.Component {
	constructor() {
		super();
		const { label: { donateto: donatetoLabel, purpose: purposeLabel } = {} } = messages || {};
		this.state = {
			donatetoLabel: donatetoLabel,
			purposeLabel: purposeLabel,
		};
	}

	formatOrgName() {
		let { label, orgName } = this.props;
		label = label && label.toString().replace(/\s/g, '').toUpperCase();
		let OName = orgName && orgName.toString().replace(/\s/g, '').toUpperCase();
		return label.includes(OName) ? '' : orgName;
	}

	render() {
		let donateto = this.state.donatetoLabel;
		let purposeLabel = this.state.purposeLabel;
		let donationName = this.props.label;
		let orgName = this.formatOrgName();
		let donationId = this.props.donationId;
		let { formatedDonationName, formatedOrgName, formatedDonationId } = {};

		if (donationName === orgName) {
			formatedDonationName = donationName;
			formatedOrgName = '';
		} else {
			formatedDonationName = donationName
		}

		if (orgName && !donationId) {
			if (donationName !== orgName) {
				formatedOrgName = `${purposeLabel} ${orgName}`;
			}
		}

		if (!orgName && donationId) {
			formatedDonationId = `${purposeLabel} ${donationId}`;
		}

		if (orgName && donationId) {
			if (donationName !== orgName) {
				formatedOrgName = `${purposeLabel} ${orgName}`;
				formatedDonationId = donationId;
			} else {
				formatedOrgName = '';
				formatedDonationId = `${purposeLabel} ${donationId}`;
			}
		}

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 donate_sub_header">
				<h4 className="text-center h4one" id="headerDonateTo">{donateto}</h4>
				<h4 className="text-center h4two" id="headerDonateToName">{formatedDonationName}</h4>
				{formatedOrgName && <h5 className="text-center" style={STYLES.headerPurpose}>{formatedOrgName}</h5>}
				{formatedDonationId && <h5 className="text-center" style={STYLES.headerDonationId}>{formatedDonationId}</h5>}
			</div>
		);
	}
}

SubHeader.propTypes = {
	label: PropTypes.string.isRequired,
	orgName: PropTypes.string.isRequired,
	donationId: PropTypes.string
};

export default SubHeader



// WEBPACK FOOTER //
// ./components/subHeader.js